import React, { useState, useContext } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import Header from '../../components/Header'
import TableListSubCategorys from '../../components/TableListSubCategorys'
import SidebarEl from '../../components/SidebarEl'
import Filter from '../../components/Filter'
import styled from 'styled-components'
import ModalCategory from '../../components/ModalCategory'
import ModalEditSubCategorys from '../../components/ModalEditSubCategorys'
import ModalSubCategorys from '../../components/ModalSubCategorys'

import MobileMenu from '../../components/MobileMenu'

import { CategorysContext } from '../../context/categorys'

import { ToastContainer, toast } from 'react-toastify';

const CardWrapper = styled.section`
    background-color: #fafafa;
    height: 100vh;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const CleanMobile = styled.div`

@media screen and (max-width:720px){
        height:120px
}
`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`

const SubCategorys = () => {

    const { animation, categorys, get, setShowModalEdit, showModalEdit,showModalSubCategory,setShowModalSubCategory,getSubCategory } = useContext(CategorysContext)

    const [modalShow, setModalShow] = React.useState(false);

    const [structure] = useState([
        {
            name: "Id",
        },
        {
            name: "Nome",
        },
    
        {
            name:"Imagem"
        },
        {
            name: "Editar"
        },
        {
            name: "Excluir"
        },


    ])

    function MyVerticallyCenteredModal(props) {
        return (
            <ModalCategory props={props} />
        );
    }
    
    function ModalSubCategory(props) {
        return (
            <ModalSubCategorys props={props} />
        );
    }

    function EditModal(props) {
        return (
            <ModalEditSubCategorys props={props} />
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper>
                <div className='colum_primary'>
                    <SidebarEl /> 
                </div>
                <FixWidthSidebar/>

                <div className='colum_secondary'>
                    <Header name="Minhas Sub Categorias" />
                    <Filter buttonName={"Adicionar"} type={1} onClick={() => setShowModalSubCategory(true)} onChange={(e) => getSubCategory(e.target.value)} animation={animation} />

                    <TableListSubCategorys structure={structure} data={categorys} />

                    <MyVerticallyCenteredModal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                    />

                    <EditModal
                        show={showModalEdit}
                        onHide={() => setShowModalEdit(false)}
                    />
                    <ModalSubCategory
                        show={showModalSubCategory}
                        onHide={() => setShowModalSubCategory(false)}
                    />
                <CleanMobile />

                </div>

                <MobileMenu />

            </CardWrapper>

        </motion.div>

    )
}

export default SubCategorys